import { useMemo, useState } from 'react';

import type { LibraryItem, MediaRef, MediaType, LibraryCollection } from '../types';
import { COLLECTIONS_CONFIG } from '../constants/collections';

import { MediaGrid } from '../components/MediaGrid';

import styles from './LibraryView.module.css';
import { CollectionIcon } from '../components/CollectionIcon';

interface LibraryViewProps {
    activeTab: MediaType;
    library: LibraryItem[];
    updateCollection: (ref: MediaRef, target: LibraryCollection) => void;
    onOpenModal: (id: number, type: MediaType) => void;
}

export const LibraryView = ({
    activeTab, library, updateCollection, onOpenModal
}: LibraryViewProps) => {
    const [filter, setFilter] = useState<LibraryCollection>('towatch');

    const itemsToDisplay = useMemo(() => {
        return library.filter(item =>
            item.collection === filter && item.media_type === activeTab
        );
    }, [library, filter, activeTab]);

    return (
        <div className={styles.libraryView}>
            <div className={styles.libraryCollectionBar}>
                {Object.entries(COLLECTIONS_CONFIG).map(([key, config]) => {
                    const collectionKey = key as LibraryCollection;
                    const isActive = filter === collectionKey;

                    return (
                        <button
                            key={collectionKey}
                            onClick={() => setFilter(collectionKey)}
                            className={`${styles.filterBtn} ${isActive ? styles.active : ''}`}
                        >
                            <CollectionIcon name={collectionKey} />
                            {config.label}
                            <span className={styles.count}>
                                {library.filter(i => i.collection === collectionKey && i.media_type === activeTab).length}
                            </span>
                        </button>
                    );
                })}
            </div>

            {itemsToDisplay.length === 0 ? (
                <div className={styles.emptyState}>
                    <p>
                        {activeTab === 'movie' ? 'Aucun film ' : 'Aucune série '}
                        {filter === 'towatch' && ' à voir'}
                        {filter === 'watched' && ' vu'}
                        {filter === 'rewatch' && ' à revoir'}
                        {filter === 'ignored' && ' ignoré'}
                    </p>
                </div>
            ) : (
                <MediaGrid
                    items={itemsToDisplay}
                    loading={false}
                    activeTab={activeTab}
                    library={library}
                    updateCollection={updateCollection}
                    onOpenModal={onOpenModal}
                />
            )}
        </div>
    );
};